var map = {
	"./angpao.webp": 2334,
	"./bonus.webp": 2335,
	"./gpi-rebate-m.webp": 2336,
	"./gpi-rebate.webp": 2337,
	"./hublot-watch-2018.webp": 2338,
	"./hublot-watch-2022.webp": 2339,
	"./iphone-13-pro-max.webp": 2340,
	"./iphone-14-pro-max.webp": 2341,
	"./login-to-m.webp": 2342,
	"./login-to.webp": 2343,
	"./mb.webp": 2344,
	"./mg-rebate-m.webp": 2345,
	"./mg-rebate.webp": 2346,
	"./np.webp": 2347,
	"./pointer.webp": 2348,
	"./pp-rebate-m.webp": 2349,
	"./pp-rebate.webp": 2350,
	"./sadface.webp": 2351,
	"./wallet-m.webp": 2352,
	"./wallet.webp": 2353,
	"./wheel-b.webp": 2354,
	"./wheel-btn.webp": 2355,
	"./wheel-indon-b.webp": 2356,
	"./wheel-indon.webp": 2357,
	"./wheel.webp": 2358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;